(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navigation"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__navEnhancedInit) return;
  window.__navEnhancedInit = true;

  function showLevel3(navEnhanced, index) {
    var col3 = navEnhanced.querySelector('.nav-enhanced-col--level3');
    var groups = col3.querySelectorAll('.nav-l3-group');
    var match = col3.querySelector('.nav-l3-group[data-nav-index="' + index + '"]');

    if (match) {
      groups.forEach(function (g) { g.style.display = 'none'; });
      col3.style.display = '';
      match.style.display = 'block';
    }
    // If the hovered level 2 item has no level 3 content, keep showing
    // whichever level 3 group was last displayed instead of hiding it.
  }

  function clearActiveL2(navEnhanced) {
    navEnhanced.querySelectorAll('.nav-l2-item--active').forEach(function (el) {
      el.classList.remove('nav-l2-item--active');
    });
  }

  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('.nav-l2-item');
    if (!item) return;
    var navEnhanced = item.closest('.nav-enhanced');
    if (!navEnhanced) return;
    clearActiveL2(navEnhanced);
    showLevel3(navEnhanced, item.dataset.navIndex);
  });

  document.querySelectorAll('.nav-enhanced[data-default-l2-index]').forEach(function (navEnhanced) {
    var dropdown = navEnhanced.closest('.dropdown.has_sub_menu');
    if (!dropdown) return;
    dropdown.addEventListener('mouseenter', function () {
      var index = navEnhanced.dataset.defaultL2Index;
      showLevel3(navEnhanced, index);
      var match = navEnhanced.querySelector('.nav-l2-item[data-nav-index="' + index + '"]');
      if (match) match.classList.add('nav-l2-item--active');
    });
  });
})();

(function () {
  if (window.__navImagePreloadInit) return;
  window.__navImagePreloadInit = true;

  function preloadNavImages() {
    var imgs = document.querySelectorAll('.nav-l3-link__imagewrap img, .mobile-nav-l3-link__imagewrap img');
    imgs.forEach(function (img) {
      var src = img.getAttribute('src');
      if (!src) return;
      var preload = new Image();
      preload.src = src;
    });
  }

  function scheduleNavImagePreload() {
    if (window.requestIdleCallback) {
      requestIdleCallback(preloadNavImages, { timeout: 2000 });
    } else {
      setTimeout(preloadNavImages, 200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleNavImagePreload();
  } else {
    window.addEventListener('load', scheduleNavImagePreload);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
